<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="modal-header">
  <h5 class="modal-title">{{ 'SDE_SUMMARIZATION_METHOD' | xdaTranslate }}</h5>
  <div class="modal-close">
    <button
      type="button"
      class="modal-close-btn"
      data-mismiss="modal"
      aria-label="Close"
      (click)="activeModal.dismiss()">
      <span aria-hidden="true" class="xgl-close"></span>
    </button>
  </div>
</div>
<div class="modal-body" tabindex="-1">
  <div [xdaTranslate]="'SDE_ABSTRACTIVE_SUMMARY_GENERATES'"></div>
  <div class="summary-lengths">
    <div>
      <span class="label" [xdaTranslate]="'SDE_SHORT'"></span
      ><span [xdaTranslate]="'SDE_SUMMARY_MOSTLY_TWO'"></span>
    </div>
    <div>
      <span class="label" [xdaTranslate]="'SDE_MEDIUM'"></span
      ><span [xdaTranslate]="'SDE_SUMMARY_MOSTLY_FOUR'"></span>
    </div>
    <div>
      <span class="label" [xdaTranslate]="'SDE_LONG'"></span
      ><span [xdaTranslate]="'SDE_SUMMARY_MOSTLY_7'"></span>
    </div>
  </div>
</div>
